export const formatPlainNumber = (value) => {
    const num = Number(value);
    if (Number.isNaN(num)) return "";
    if (Number.isInteger(num) || num % 1 === 0) return String(Math.round(num));
    return String(num);
};

export const formatMatrixPrice = (value, currency) => {
    if (value == null || value === "") return null;
    const num = Number(value);
    if (Number.isNaN(num)) return null;
    return currency === "USD" ? num.toFixed(2) : formatPlainNumber(num);
};

export const formatChartPrice = (value, currency = "SYP") => {
    const num = Number(value);
    if (Number.isNaN(num)) return "";
    const suffix = currency === "USD" ? "$" : "ل.س";
    const formatted = currency === "USD" ? num.toFixed(2) : formatPlainNumber(num);
    return `${formatted} ${suffix}`;
};

export const formatChartAxisTick = (value) => formatPlainNumber(value);
